import { useContext, useEffect, useState } from "react";
import useInterval from "lib/useInterval";
import { UserContext } from "lib/UserContext";
import { Link } from "react-router-dom";

export default function PaceCard(props) {
  const [slaCount, setSlaCount] = useState("--");
  const [timestamp, setTimestamp] = useState("--");
  const [data, setData] = useState("--");
  const { user, setUser } = useContext(UserContext);
  const [publicComments, setPublicComments] = useState(0);

  function getCurrentPace(publicComments) {
    // need a function that fetches user.public_comments_today
    const d = new Date();
    const minutesLeft = (user.ending_hour - d.getHours()) * 60 - d.getMinutes();
    console.log(minutesLeft + " min left");
    const ticketsLeft = user.daily_goal - publicComments;
    const minutesPerTicket = Math.floor(minutesLeft / ticketsLeft);

    return { timestamp: d, minutesPerTicket: minutesPerTicket };
  }
  useEffect(() => {
    fetch(`https://zendash.fly.dev/api/collections/users/records/${user.id}`)
      .then((response) => response.json())
      .then((record) => {
        console.log(
          `PaceCard rendered this--public comments today: ${record.public_comments_today}`
        );
        setUser(record);
        const data = getCurrentPace(record.public_comments_today);
        setData(data);
      });
  }, []);

  useInterval(() => {
    fetch(`https://zendash.fly.dev/api/collections/users/records/${user.id}`)
      .then((response) => response.json())
      .then((record) => {
        console.log(
          `PaceCard rendered this--public comments today: ${record.public_comments_today}`
        );
        setUser(record);
        const data = getCurrentPace(record.public_comments_today);
        setData(data);
      });
  }, 60000);

  return (
    <div className="card shadow mb-4 text-center">
      <h6 className="card-header text-secondary">
        {props.title ? props.title : "Pace"}
      </h6>
      {user.ending_hour && user.daily_goal ? (
        <>
          {" "}
          <div className="card-body">
            <h4 className="card-text">{data.minutesPerTicket} min </h4>
            <span className="">per ticket</span>
          </div>
          <div class="card-footer">
            <span className="text-muted">
              till{" "}
              {user.ending_hour < 12
                ? `${user.ending_hour}am`
                : `${user.ending_hour - 12}pm`}
            </span>
          </div>
        </>
      ) : (
        <>
          {" "}
          <div className="card-body">
            <Link className="text-muted" to="/settings">
              Configure
            </Link>
          </div>
        </>
      )}
    </div>
  );
}
